import PaymentFlow from '@cont/Checkout/PaymentFlow';
import { PaymentMethodsContextProvider } from '@context/PaymentMethodsContext';
import PaymentPageLayout from '@layout/PaymentLayout/PaymentPageLayout';
import {
  fetchPurchaseDetails,
  getPurchaseDetailsEndpoint
} from '@api/fetchers/checkout';
import { SWRConfig } from 'swr';
import { useRouter } from 'next/router';

const PaymentPage = ({ purchaseDetails = null }) => {
  const router = useRouter();
  const { subscriptionUID } = router.query;

  return (
    <SWRConfig
      value={{
        fallback: purchaseDetails
          ? {
              [getPurchaseDetailsEndpoint(subscriptionUID)]: purchaseDetails
            }
          : {}
      }}
    >
      <PaymentMethodsContextProvider>
        <PaymentFlow />
      </PaymentMethodsContextProvider>
    </SWRConfig>
  );
};

PaymentPage.pageInfo = {
  isMWebSupported: true,
  name: 'Payment Page',
  layoutOptions: {
    disableDarkMode: true,
    hideIntercom: true,
    hideFreshbot: true
  }
};

PaymentPage.Layout = PaymentPageLayout;

// CDN cache with a TTL of 4hrs is enabled for this page
export const getStaticProps = async ({ params: query }) => {
  const { subscriptionUID } = query;

  try {
    const purchaseDetails = await fetchPurchaseDetails(subscriptionUID);

    if (purchaseDetails?.subscription) {
      return { props: { purchaseDetails }, revalidate: 1 * 60 };
    }
    return { props: { purchaseDetails: null }, revalidate: 1 * 60 };
  } catch (err) {
    return { props: { purchaseDetails: null }, revalidate: 1 * 60 };
  }
};

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking'
  };
};

export default PaymentPage;
